import { render, staticRenderFns } from "./ranking-style-3.vue?vue&type=template&id=6ce0580b&"
import script from "./ranking-style-3.vue?vue&type=script&lang=js&"
export * from "./ranking-style-3.vue?vue&type=script&lang=js&"
import style0 from "./ranking-style-3.vue?vue&type=style&index=0&id=6ce0580b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports